import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { valueRender } from '@repo/toolkit/conditional-render'
import { StringFormatter } from '@repo/toolkit/string'
import { FatherIcon, LocationOneIcon, MotherIcon, TelephoneIcon } from '@repo/ui/icons'
import Loader from '@repo/ui/loader'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getEnrollmentHostFamily } from '../../../../api/enrollments/get-enrollment-host-family'
import { useNativeCountryName } from '../../../../lib/hooks/use-native-country-name'
import { enrollmentHostFamilyFields } from '../../../../lib/types/fields/host-families/host-family'
import { formatPhoneNumber } from '../../../../utils/functions/format-phone-number'
import OverviewCard from '../overview-card'

type Props = {
  enrollmentId: number
}

const HostFamilyCard = ({ enrollmentId }: Props) => {
  const nativeCountryName = useNativeCountryName()
  const { data, isPending } = useQuery({
    queryKey: ['enrollment-host-family', enrollmentId],
    queryFn: async () => getEnrollmentHostFamily(enrollmentId, enrollmentHostFamilyFields),
    enabled: !!enrollmentId
  })

  if (isPending) return <Loader center />

  if (!data)
    return (
      <Typography variant="label-medium" color={tailwindColors.grey.lighter}>
        Aucune information de famille hôtesse disponible.
      </Typography>
    )

  return (
    <OverviewCard
      title="Coordonnées de la famille-hôtesse de votre enfant"
      subtitle={`Famille hotesse - ${data.familyName}`}
      bulletPoints={[
        {
          icon: LocationOneIcon,
          label: `${data.address1}${data.address2 ? ` ${data.address2}` : ''}, ${data.zipCode} ${data.city}, ${nativeCountryName(data.country)}`
        },
        {
          icon: FatherIcon,
          label: `${data.parent2FirstName ? StringFormatter.capitalize(data.parent2FirstName) : '-'} ${data.parent2Position ? `(${data.parent2Position})` : ''}`
        },
        {
          icon: MotherIcon,
          label: `${data.parent1FirstName ? StringFormatter.capitalize(data.parent1FirstName) : '-'} ${data.parent1Position ? `(${data.parent1Position})` : ''}`
        },
        {
          icon: TelephoneIcon,
          label: `Téléphone: ${valueRender(data.parent1PhoneNumber, (phone) => formatPhoneNumber(phone))}`
        }
      ]}
      imagePath="/family.png"
    />
  )
}

export default HostFamilyCard
